import script from "./nav.vue?vue&type=script&setup=true&lang=js"
export * from "./nav.vue?vue&type=script&setup=true&lang=js"

import "./nav.vue?vue&type=style&index=0&id=130bf7d1&lang=less&scoped=true"

import exportComponent from "G:\\GitWorkSpace\\water\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-130bf7d1"]])

export default __exports__